import { useContext, useState, useEffect, useCallback } from 'react'
import { withStyles } from '@material-ui/core/styles'

import { Modal, Box } from '@material-ui/core'
import dayjs from 'dayjs'
import { format } from 'date-fns'
import styles from '../dashboardStyles'
import validator from 'validator'

// Components  
import DailPad from './DailPad'
import CallerInfo from './CallerInfo'
import CallDescription from './CallDescription'
import CallHistory from './CallHistory'

//  functions 
import { backendHosts, apiUrl } from '../../../../../ui-utils/apiConfig'
import { httpRequest } from '../../../../../ui-utils/api'
import { reducerContext } from '../../../../../contextApi\'s/contextApi\'s'
import snackError from '../../../../../helpers/snackError'

const CallerModal = ({ classes }) => {
    const { state, dispatch } = useContext(reducerContext)

    const {
        callDomain,
        callHistoryChat,
        callerInfoModal,
        callUuid,
        customerEmail,
        customerLocation,
        customerState,
        customerPortfolios,
        customerName,
        customerPhoneNumber,
        errorMsg,
        isCallHangUp,
        isCallActive,
        showDomain,
        showTransfer,
        tagPreviousIssue,
        timer,
        uId,
        callNumber,
        inBound,
        clientId, // srini - 28/11/24
        clientRefCode, // srini - 28/11/24
    } = state

    const [callDescription, setCallDescription] = useState('')
    const [callDescriptionError, setCallDescriptionError] = useState(false)
    const [callStatus, setCallStatus] = useState('')
    const [comment, setComment] = useState('')
    const [commentsError, setCommentsError] = useState(false)
    const [callDomainError, setCallDomainError] = useState(false)
    const [dateError, setDateError] = useState(false)
    const [errType, setErrType] = useState(0)
    const [selectDate, setSelectDate] = useState(null)
    // Adjusted date formats - 23-07-24 - Dev Srini
    const [followUpDate, setFollowUpDate] = useState('')
    const [followUpTime, setFollowUpTime] = useState('')
    const [pendingBy, setPendingBy] = useState('')
    const [pendingByError, setPendingByError] = useState(false)
    const [statusError, setStatusError] = useState(false)
    const [transferStatus, SetTransferStatus] = useState(false)
    const [updateTaskObj, setUpdateTaskObj] = useState({})

    useEffect(() => {
        if (Object.values(updateTaskObj).length > 0 && callStatus && tagPreviousIssue.length > 0) {
            (async () => {
                try {
                    const taskData = await httpRequest({
                        endPoint: `${apiUrl.updateTask}`,
                        method: "post",
                        instance: "instanceOne",
                        requestBody: updateTaskObj,
                    })
                    if (taskData.success) {
                        if (callStatus == 'Closed') {
                            dispatch({
                                type: 'REMOVE_CUSTOMER_PENDING_TASKS',
                                payload: taskData.msg.msg[0].uid
                            })
                        }
                        else {
                            dispatch({
                                type: 'UPDATE_CUSTOMER_PENDING_TASKS',
                                payload: {
                                    uid: taskData.msg.msg[0].uid,
                                    newTask: updateTaskObj.edit_task[updateTaskObj.edit_task.length - 1]
                                }
                            })
                        }
                    }
                    // Dev Srini 25/10/24
                    else{
                        console.log('Error in Update Task API', taskData)
                    }
                }
                catch (error) {
                    console.log('Error in Update Task API', error)
                }
            })()
        }
    }, [updateTaskObj, callHistoryChat, tagPreviousIssue])
    // updating followup date as none - 25/08/24 - Dev Srini
    useEffect(() => {
        if (callStatus === "Closed" || callStatus === "Transfer") {
            setFollowUpDate("none")
        }
    }, [callStatus])

    const formatDateForDisplay = (date) => {
        return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    }

    const handleDateChange = (newDate) => {
        const formattedDate = formatDateForDisplay(newDate)
        setSelectDate(formattedDate)
        setFollowUpDate(formattedDate.split(' ')[0])
        setFollowUpTime(formattedDate.split(' ')[1])
    }

    const createTask = async () => {
        const currentTimeIST = format(new Date(), 'yyyy-MM-dd HH:mm:ss', { timeZone: 'Asia/Kolkata' })

        const taskPayload = {
            call_description: callDescription,
            createdby: localStorage.getItem('user_id1'),
            createdon:currentTimeIST,
            comment: comment,
            status: callStatus,
            followup_date: followUpDate,
            followup_time: followUpTime,
            pendingby: pendingBy,
            updatedby: localStorage.getItem('user_id1'),
            updatedon: currentTimeIST
        }
        // if transfer adds dep/agent details - 25/08/24 - Dev Srini
        const taskPay = {
            customer_number: parseInt(customerPhoneNumber),
            customer_email: customerEmail,
            description: callDescription,
            followup_datetime: `${followUpDate} ${followUpTime}`.trim(),
            status: callStatus == 'Transfer' ? `${callStatus} ${callDomain}` : callStatus,
            task: [taskPayload],
            task_datetime: currentTimeIST,
            user_id: parseInt(localStorage.getItem('user_id1')),
        }

        // trim space - 25/08/24 - Dev Srini
        if (Object.keys(taskPayload).length > 0) {
            const updateTaskPay = {
                where_customer_number: parseInt(customerPhoneNumber),
                where_customer_email: customerEmail,
                edit_followup_datetime: `${followUpDate} ${followUpTime}`.trim(),
                edit_status: callStatus,
                edit_task: [...callHistoryChat, taskPayload],
                edit_task_datetime: currentTimeIST,
                where_uid: uId,
                where_user_id: parseInt(localStorage.getItem('user_id1')),
            }

            setUpdateTaskObj(updateTaskPay)
        }

        if (tagPreviousIssue.length === 0) {
            try {
                const taskData = await httpRequest({
                    endPoint: `api/task/create`,
                    method: "post",
                    instance: "instanceOne",
                    requestBody: taskPay,
                })

                if (taskData.success) {
                    const taskObjResult = {
                        uid: taskData.msg.msg[0].uid,
                        log_datetime: currentTimeIST,
                        user_id: parseInt(localStorage.getItem('user_id1')),
                        customer_number: parseInt(customerPhoneNumber),
                        customer_email: customerEmail,
                        task_datetime: currentTimeIST,
                        task: [taskPayload],
                        task_updated: currentTimeIST,
                        status: callStatus,
                        description: callDescription,
                        followup_datetime: `${followUpDate} ${followUpTime}`
                    }

                    dispatch({
                        type: 'ADD_CUSTOMER_PENDING_TASKS',
                        payload: taskObjResult
                    })
                }
                else{
                    console.log('Error in Create Task API', taskData)
                }
            } catch (error) {
                console.log('Error in Create Task API', error)
            }
        }
    }
    // Engage call submit api - srini on 02-04-25 for engagement section
    const createEngagement = async () => {
        const payload = { client_id: clientId, lastcall_disp: callDescription }

        try {
            const result = await httpRequest({
                endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.engagementCall}`,
                method: "post",
                instance: "instanceOne",
                requestBody: payload,
            })

            if (!result.status === 200) {
                console.log('Error in Engagement call submit API response', result)
            }
        } catch (error) {
            console.log('Error in Create Engagement call submit API', error)
        }
    }

    const submitCallerInfo = async () => {
        let isOk = true
        const validateField = (field, errorMsg, errorType) => {
            if (!field.trim()) {
                isOk = false
                setErrType(errorType)
                dispatch({
                    type: 'SET_ERROR',
                    payload: errorMsg
                })
            }
            else if (customerLocation && customerName && customerState) {
                dispatch({
                    type: 'SET_ERROR',
                    payload: ''
                })
            }
        }

        validateField(customerName, 'Enter the name', 1)
        validateField(customerLocation, 'Enter the location', 3)
        validateField(customerState, 'Enter the state', 4)

        if (!validator.isEmail(customerEmail)) {
            isOk = false
            setErrType(5)
            dispatch({
                type: 'SET_ERROR',
                payload: 'E-Mail is Not Valid'
            })
        }
        // validation correction by srini on 02-04-25 for engagement section
        if (!customerPhoneNumber || customerPhoneNumber.toString().length !== 10) {
            isOk = false;
            setErrType(2);
            dispatch({
                type: 'SET_ERROR',
                payload: 'Enter a valid phone number'
            });
        }        

        if (!callDescription.trim()) {
            isOk = false
            setCallDescriptionError(true)
        } else {
            setCallDescriptionError(false)
        }

        if (!comment.trim()) {
            isOk = false
            setCommentsError(true)
        } else {
            setCommentsError(false)
        }

        if (!callStatus) {
            isOk = false;
            setStatusError(true)
        } else {
            setStatusError(false)
        }

        if (callStatus === 'Pending with me') {
            if (!followUpDate || !followUpTime) {
                isOk = false;
                setDateError(true)
            } else {
                setDateError(false)
            }
        }

        if (callStatus === 'Pending with others') {
            if (!followUpDate || !followUpTime) {
                isOk = false;
                setDateError(true)
            } else {
                setDateError(false)
            }

            if (!pendingBy.trim()) {
                isOk = false
                setPendingByError(true)
            } else {
                setPendingByError(false)
            }
        }

        if (callStatus === 'Transfer') {
            if (!callDomain.trim()) {
                isOk = false
                setCallDomainError(true)
            } else {
                setCallDomainError(false)
            }
        }

        if (callStatus && isOk) {
            createTask()
            createEngagement()
        }

        if (!isOk) {
            return
        }
        // if transfer adds dep/agent details - 25/08/23 - Dev Srini
        const callerInfo = {
            agentid: localStorage.getItem('user_id1'),
            phone: customerPhoneNumber,
            mobileno: customerPhoneNumber,
            name: customerName,
            createdby: localStorage.getItem('user_id1'),
            createdon: format(new Date(), 'yyyy-MM-dd HH:mm:ss', { timeZone: 'Asia/Kolkata' }),
            city: customerLocation,
            state: customerState,
            call_uuid: callUuid,
            call_description: callDescription,
            comment,
            status: callStatus == 'Transfer' ? `${callStatus} ${callDomain}` : callStatus,
            followup_date: followUpDate,
            pendingby: pendingBy,
            followup_time: followUpTime,
            updatedby: localStorage.getItem('user_id1'),
            updatedon: format(new Date(), 'yyyy-MM-dd HH:mm:ss', { timeZone: 'Asia/Kolkata' }),
            other:{
                clientId,
                custEmail:customerEmail,
                refCode: clientRefCode // srini - 28/11/24
            }
        }

        try {
            const callerInformation = await httpRequest({
                endPoint: `${apiUrl.submitForm}`,
                method: 'post',
                instance: 'instanceOne',
                requestBody: callerInfo,
            })

            if (callerInformation.success) {
                dispatch({
                    type: 'SET_CUSTOMER_LOCATION',
                    payload: ''
                })

                dispatch({
                    type: 'SET_CUSTOMER_STATE',
                    payload: ''
                })

                setCallDescription('')
                setComment('')
                setCallStatus('')
                setPendingBy('')
                setFollowUpDate('')
                setSelectDate(null)
                setFollowUpTime('')
                setDateError(false)
                setPendingByError(false)
                SetTransferStatus(false)

                const resetActions = [
                    { type: 'SET_DISPLAY_NUMBER', payload: '' },
                    { type: 'SET_CUSTOMER_NAME', payload: '' },
                    { type: 'SET_ERROR', payload: "Call details submitted successfully" },
                    { type: 'SET_MY_SNACK', payload: snackError.mySucc },
                    { type: 'SET_CALLER_INFO_MODAL', payload: false },
                    { type: 'SET_BUTTON', payload: false },
                    { type: 'SET_TAG_PENDING_ISSUE', payload: '' },
                    { type: 'SET_CUSTOMER_PHONE_NUMBER', payload: '' },
                    { type: 'SET_CUSTOMER_EMAIL', payload: '' },
                    { type: 'SET_CALL_HISTORY', payload: [] },
                    { type: 'SET_CALL_HISTORY_CHAT', payload: [] },
                    { type: 'IS_CALL_HANG_UP', payload: true },
                    { type: 'SET_START_CALL', payload: false },
                    { type: 'SET_CALL_DURATION', payload: 0 },
                    { type: 'SET_CALL_BUTTON_TYPE', payload: '' },
                    { type: 'SET_OUT_BOUND_CALLING', payload: false },
                    { type: 'SET_CALL_ACCEPT', payload: false },
                    { type: 'SET_CALL_TIMER_RESET', payload: 0 },
                    { type: 'SET_SHOW_DOMAIN', payload: false },
                    { type: 'SET_IN_BOUND', payload: '' },
                    { type: 'SET_CLIENT_ID', payload: '' }
                ]

                resetActions.forEach(action => dispatch(action))
                // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
                try {

                    await window.sipPublish('open', 'Idle', 'I am Idle')
                    console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

                    dispatch({
                        type: 'SET_AGENT_PUBLISH_STATS',
                        payload: 'open'
                    })
                }
                catch (error) {
                    console.error('Failed to publish SIP status:', error)
                }
            } else {
                dispatch({
                    type: 'SET_SHOW_ERROR',
                    payload: true
                })

                dispatch({
                    type: 'SET_ERROR',
                    payload: callerInformation.message
                })

                dispatch({
                    type: 'SET_MY_SNACK',
                    payload: snackError.myError
                })

                console.log('Error in Submit Form API', callerInformation)
            }
        }

        catch (error) {
            dispatch({
                type: 'SET_SHOW_ERROR',
                payload: true
            })

            dispatch({
                type: 'SET_ERROR',
                payload: 'Oops, something went wrong'
            })

            dispatch({
                type: 'SET_MY_SNACK',
                payload: snackError.myError
            })
            
            console.log("Error in Submit Form API: ", error)
        }
    }

    const handleName = useCallback((e) => {
        dispatch({
            type: 'SET_CUSTOMER_NAME',
            payload: e.target.value
        })
        setErrType(0)
    }, [dispatch, setErrType])

    const handleSelectedEmail = useCallback((ele) => {
        dispatch({
            type: 'SET_CUSTOMER_EMAIL',
            payload: ele?.email
        })
        // using nullish coalescing operator (??)
        dispatch({
            type: 'SET_CUSTOMER_NAME',
            payload: ele?.full_name ?? ''
        })

        dispatch({
            type: 'SET_CUSTOMER_PHONE_NUMBER',
            payload: ele?.phone ?? ''
        })

        dispatch({
            type: 'SET_CUSTOMER_LOCATION',
            payload: ele?.city ?? ''
        })

        dispatch({
            type: 'SET_CUSTOMER_STATE',
            payload: ele?.state ?? ''
        })

        dispatch({
            type: 'SET_CLIENT_ID',
            payload: ele?.accountno_prefix + ele?.accountno ?? ''
        })

    }, [dispatch])

    const handleEmail = useCallback((e) => {

        dispatch({
            type: 'SET_CUSTOMER_EMAIL',
            payload: e.target.value
        })
    }, [dispatch])

    const handlePhoneNumber = useCallback((e) => {
        dispatch({
            type: 'SET_CUSTOMER_PHONE_NUMBER',
            payload: e.target.value
        })
        setErrType(0)
    }, [dispatch, setErrType])

    const handleLocation = useCallback((e) => {
        dispatch({
            type: 'SET_CUSTOMER_LOCATION',
            payload: e.target.value
        })

        setErrType(0)
    }, [dispatch, setErrType])

    const handleStateName = useCallback((e) => {
        dispatch({
            type: 'SET_CUSTOMER_STATE',
            payload: e.target.value
        })
        setErrType(0);
    }, [dispatch, setErrType])

    const handlePendingBy = useCallback((e) => {
        setPendingBy(e.target.value)
        setErrType(0)
    }, [setPendingBy, setErrType])

    const handleCallDomain = useCallback((e) => {
        dispatch({
            type: 'SET_CALL_DOMAIN',
            payload: e.target.value
        })
    }, [dispatch])

    const handleCallStatus = useCallback((e) => {
        setCallStatus(e.target.value)
    }, [setCallStatus])

    const handleComment = useCallback((e) => {
        setComment(e.target.value)
        setErrType(0)
    }, [setComment, setErrType])

    const handleCallDescription = useCallback((e) => {
        setCallDescription(e.target.value)
        setErrType(0)
    }, [setCallDescription, setErrType])

    const handleTransferStatus = useCallback(() => {
        SetTransferStatus(true)
    }, [SetTransferStatus])

    const handleTransferText = () => {
        setCallStatus("Transfer")
    }

    return (
        <Modal
            open={callerInfoModal}
            style={{ margin: '10px' }}
            BackdropProps={{
                style: {
                    backgroundColor: 'rgba(0, 0, 0, 0)'
                },
            }}
            disableAutoFocus // srini - 12/12/24
            disableEnforceFocus // srini - 12/12/24
        >
            <Box className={classes.callerModalCard}  >
                <div style={{ display: 'flex' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: '75%' }}>

                        <div style={{ flex: '50%', display: 'flex' }}>
                            <CallerInfo
                                customerEmail={customerEmail}
                                customerLocation={customerLocation}
                                customerState={customerState}
                                customerPortfolios={customerPortfolios}
                                dispatch={dispatch}
                                errType={errType}
                                errorMsg={errorMsg}
                                customerName={customerName}
                                customerPhoneNumber={customerPhoneNumber}
                                handleLocation={handleLocation}
                                handleName={handleName}
                                handleEmail={handleEmail}
                                handleSelectedEmail={handleSelectedEmail}
                                handlePhoneNumber={handlePhoneNumber}
                                handleStateName={handleStateName}
                                callNumber={callNumber}
                            />

                            <div style={{
                                background: '#000', flexShrink: 0, height: '340px', margin: '15px', width: '1px'
                            }}></div>

                            <CallDescription
                                callDescription={callDescription}
                                callDescriptionError={callDescriptionError}
                                callDomain={callDomain}
                                callDomainError={callDomainError}
                                callStatus={callStatus}
                                comment={comment}
                                commentsError={commentsError}
                                dateError={dateError}
                                dispatch={dispatch}
                                selectDate={selectDate}
                                handleCallDescription={handleCallDescription}
                                handleCallDomain={handleCallDomain}
                                handleCallStatus={handleCallStatus}
                                handleComment={handleComment}
                                handleDateChange={handleDateChange}
                                handlePendingBy={handlePendingBy}
                                pendingBy={pendingBy}
                                pendingByError={pendingByError}
                                showDomain={showDomain}
                                statusError={statusError}
                                submitCallerInfo={submitCallerInfo}
                                tagPreviousIssue={tagPreviousIssue}
                                transferStatus={transferStatus}
                                isCallHangUp={isCallHangUp}
                                inBound={inBound}
                                clientId={clientId}
                            />
                        </div>

                        <CallHistory />
                    </div>


                    <div style={{
                        background: '#000', flexShrink: 0, height: '596px', margin: '15px px px px', width: '1px'
                    }}></div>

                    <DailPad
                        customerPhoneNumber={customerPhoneNumber}
                        dispatch={dispatch}
                        timer={timer}
                        isCallActive={isCallActive}
                        showTransfer={showTransfer}
                        transferStatus={transferStatus}
                        handleTransferStatus={handleTransferStatus}
                        isCallHangUp={isCallHangUp}
                        callNumber={callNumber}
                        handleTransferText={handleTransferText}
                    />
                </div>
            </Box>
        </Modal>
    )
}

export default withStyles(styles)(CallerModal)